import con from '../../../../connection';
var path = '/comments';
var comments = function (url) { return function () { return ({
    get: function (options) { return con.get(url + path, {}, options === null || options === void 0 ? void 0 : options.noError, options === null || options === void 0 ? void 0 : options.noNetworkError); },
    post: function (param, option) { return con.post(url + path, param, option === null || option === void 0 ? void 0 : option.noError, option === null || option === void 0 ? void 0 : option.timeoutMS); },
}); }; };
export default comments;
